/* Presentation only. Does not change review text, ratings, or photos.
   Rewrites the summary count to "Based on N reviews" and marks an active
   rating or media filter. Safe to remove with the theme setting. */
(function () {
  var COUNT = '.kl_reviews__summary__stars__count';

  function countLabel(text) {
    var match = String(text || '').replace(/\s+/g, ' ').trim().match(/^([\d,]+)\s+reviews?$/i);
    if (!match) return '';
    var n = match[1];
    return 'Based on ' + n + ' ' + (n === '1' ? 'review' : 'reviews');
  }

  function wrapper() {
    return document.getElementById('klaviyo-product-reviews-wrapper');
  }

  function paint(root) {
    if (!root) return;
    var count = root.querySelector(COUNT);
    if (count) {
      var next = countLabel(count.textContent);
      if (next && count.textContent !== next) count.textContent = next;
    }
    var pills = root.querySelectorAll('.kl_reviews__filters__pill');
    var i;
    for (i = 0; i < pills.length; i++) {
      var pill = pills[i];
      var select = pill.querySelector('select');
      var button = pill.querySelector('button[aria-checked]');
      var active = false;
      if (select && select.id && select.id.indexOf('rating') !== -1) {
        active = select.value !== '' && select.value !== '0';
      }
      if (button) active = button.getAttribute('aria-checked') === 'true';
      pill.classList.toggle('is-runnies-active', active);
    }
  }

  function mount() {
    return document.getElementById('fulfilled-reviews-all')
      || document.getElementById('klaviyo-reviews-all')
      || document.getElementById('klaviyo-product-reviews-wrapper');
  }

  var observer = null;

  function watch() {
    var node = mount();
    if (!node) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      paint(wrapper());
    });
    observer.observe(node, { childList: true, subtree: true, characterData: true });
    paint(wrapper());
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('#klaviyo-product-reviews-wrapper')) {
      paint(wrapper());
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('#klaviyo-product-reviews-wrapper .kl_reviews__filters')) {
      window.setTimeout(function () { paint(wrapper()); }, 0);
    }
  }, true);

  function start() {
    watch();
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      watch();
      if (wrapper() || tries > 40) window.clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
